import {callGet, callPost} from "../../lib/api-private";
import {GetTenantResponse} from "../../generated-client/model/get-tenant-response";
import {GetInteractionsCountResponse} from "../../generated-client/model/get-interactions-count-response";

export const getInteractionsCount = async () : Promise<GetInteractionsCountResponse> => {
  const data = await callGet("/interaction/count-by-type");
  return data;
};
